import { gql } from '@apollo/client';

export const AI_CREATE_PROMPT = gql`
    mutation CreatePrompt( $input: CreatePromptInput! ) {
        createPrompt( input: $input ) {
            id
            companyId
            label
            prompt
            sql
            isSaved
            reportCount
            createdAt
            updatedAt
        }
    }
`;

export default AI_CREATE_PROMPT;
